import { __awaiter } from "tslib";
import * as React from 'react';
import LabSimService, { NoSelectionIndicator, StateContext, } from '../services/LabSimService';
import LoadingPage from './LoadingPage';
import SupportBox from '../controls/SupportBox';
import SuccessPage from './SuccessPage';
import { Routes } from '../Routing';
import GradingControl from '../controls/GradingControl';
import ModulePublishControl from '../controls/ModulePublishControl';
import PageFooter from '../partials/PageFooter';
import { createRef } from 'react';
import styles from './CustomExams.module.less';
import { T } from '@testout/labsim-ui-atomics';
import PlatformHelper from '../helpers/PlatformHelper';
export default React.forwardRef((props, ref) => (React.createElement(StateContext.Consumer, null, (stateContext) => React.createElement(CustomExams, Object.assign({}, props, { context: stateContext })))));
class CustomExams extends React.Component {
    constructor(props) {
        super(props);
        this.contentItemsSubmitRef = createRef();
        this.selectProduct = (selectedExam) => {
            this.setState({
                canCreate: selectedExam !== NoSelectionIndicator && this.state.possiblePoints > 0,
                selectedExam: selectedExam,
            });
        };
        this.selectTeacher = (teacherGuid) => {
            const selectedExams = [];
            let canSelectExam = false;
            if (this.props.context.customExams && this.props.context.customExams.customExamsData) {
                this.props.context.customExams.customExamsData.forEach((customExam) => {
                    if (customExam.teacherGuid === teacherGuid) {
                        selectedExams.push(customExam);
                    }
                });
            }
            if (selectedExams.length > 0) {
                canSelectExam = true;
                selectedExams.sort((a, b) => {
                    return a.title.localeCompare(b.title, undefined, {
                        numeric: true,
                        sensitivity: 'base',
                    });
                });
            }
            this.setState({
                canCreate: false,
                canSelectExam: canSelectExam,
                selectedExam: '',
                selectedExams: selectedExams,
                selectedTeacherGuid: teacherGuid,
            });
        };
        this.getDistinctIsbns = () => {
            const distinctIsbns = [];
            if (this.props.context.customExams && this.props.context.customExams.customExamsData) {
                this.props.context.customExams.customExamsData.forEach((customExam) => {
                    if (customExam.productData) {
                        customExam.productData.forEach((product) => {
                            if (product.isbn &&
                                product.isbn.trim() !== '' &&
                                !distinctIsbns.includes(product.isbn)) {
                                distinctIsbns.push(product.isbn);
                            }
                        });
                    }
                });
            }
            this.getExamsVersion(distinctIsbns);
        };
        this.onContinue = () => {
            var _a, _b;
            if (this.props.context.customExams && this.props.context.customExams.customExamsData) {
                const customExam = this.props.context.customExams.customExamsData.find((c) => c.examGuid === this.state.selectedExam);
                if (customExam) {
                    this.setState({ isCreating: true, isReadyToPost: false });
                    let productVersionId = (_b = (_a = customExam.productData[0]) === null || _a === void 0 ? void 0 : _a.productVersionId) !== null && _b !== void 0 ? _b : 0;
                    if (productVersionId === 0) {
                        const nonZeroProductVersion = customExam.productData.find((pd) => pd.productVersionId && pd.productVersionId !== 0);
                        if (nonZeroProductVersion) {
                            productVersionId = nonZeroProductVersion.productVersionId;
                        }
                    }
                    const selectedResources = {
                        isPublish: this.state.selectedToPublish,
                        productVersionId: productVersionId,
                        resources: [
                            {
                                allowedAttempts: this.state.attemptsAllowed,
                                assignmentGroup: this.state.selectedAssignmentGroup,
                                assignmentType: 'customexam',
                                isGraded: this.state.isGraded,
                                moduleGroup: this.state.selectedModule,
                                pointsPossible: this.state.isGraded ? this.state.possiblePoints : 0,
                                resourceGuid: customExam.examGuid,
                            },
                        ],
                    };
                    LabSimService.createCustomExamAssignment(selectedResources, (data) => this.createCallback(data), (err) => this.setState({ error: err, isCreating: false, isReadyToPost: false }));
                }
            }
        };
        this.goToHome = () => {
            this.props.history.push(Routes.HOME);
        };
        this.getCustomQuizOptions = () => {
            if (this.state.selectedExams) {
                return this.state.selectedExams.map((exam) => {
                    var _a, _b;
                    let hasMatchingVersions = true;
                    let lockedMigratedFromProduct = false;
                    let lockedMigratedToProduct = false;
                    const migratedFrom = this.props.context.getMigratedFromLockedProducts();
                    const migratedTo = this.props.context.getMigratedToLockedProducts();
                    if (this.props.context.lockedVersions && this.props.context.lockedVersions.length > 0) {
                        const hasAtLeastOneMatchingIsbn = this.props.context.lockedVersions.some((l) => exam.productData.some((e) => e.isbn === l.isbn));
                        lockedMigratedFromProduct = migratedFrom.some((m) => m.versions.some((v) => exam.productData.some((e) => e.productVersionId === v.productVersionId)));
                        lockedMigratedToProduct = migratedTo.some((m) => m.versions.some((v) => exam.productData.some((e) => e.productVersionId === v.productVersionId)));
                        if (hasAtLeastOneMatchingIsbn) {
                            hasMatchingVersions = exam.productData
                                .filter((e) => {
                                return (this.props.context.lockedVersions.find((l) => l.isbn === e.isbn) != null);
                            })
                                .every((e) => {
                                return (this.props.context.lockedVersions.find((l) => l.isbn === e.isbn)
                                    .productVersionId === e.productVersionId);
                            });
                        }
                    }
                    const hasCampusEnabledVersions = (_b = (_a = this.props.context.products) === null || _a === void 0 ? void 0 : _a.campusEnabledVersions) === null || _b === void 0 ? void 0 : _b.some((p) => {
                        return exam.productData.some((pd) => pd.productVersionId === p);
                    });
                    let title = exam.title;
                    const isbns = exam.productData
                        .map((pd) => { var _a; return (_a = pd.isbn) === null || _a === void 0 ? void 0 : _a.trim(); })
                        .filter((isbn) => !!isbn)
                        .join(', ');
                    if (isbns) {
                        title += ` (${isbns})`;
                    }
                    return (React.createElement(T.Select.Option, { key: exam.examGuid, value: exam.examGuid, disabled: !hasMatchingVersions ||
                            lockedMigratedFromProduct ||
                            lockedMigratedToProduct ||
                            !hasCampusEnabledVersions }, title));
                });
            }
            return [];
        };
        this.state = {
            attemptsAllowed: -1,
            canCreate: false,
            canSelectExam: false,
            error: '',
            isCreating: false,
            isGraded: true,
            isReadyToPost: false,
            linkCreated: false,
            possiblePoints: 100,
            postParams: [],
            response: undefined,
            selectedAssignmentGroup: '',
            selectedExams: [],
            selectedModule: '',
            selectedToPublish: false,
            uniqueIsbns: [],
            loading: false,
        };
    }
    createCallback(response) {
        if (response.isValid &&
            this.props.context.isFamilyDesire2Learn() &&
            !this.props.context.isIntegrationLTIAdvantage()) {
            this.setState({ isCreating: false, isReadyToPost: false, response: response });
            if (response.redirectUrl !== 'undefined') {
                window.location.assign(response.redirectUrl); // this closes the window we are on
            }
        }
        else if (response.error) {
            this.setState({ error: response.error, isCreating: false, isReadyToPost: false });
        }
        else {
            this.setState({ linkCreated: true, response: response }, () => {
                var _a;
                if (response.responseType === 2) {
                    (_a = this.contentItemsSubmitRef.current) === null || _a === void 0 ? void 0 : _a.click();
                }
            });
        }
    }
    getTeacherOptions(stateContext) {
        var _a;
        if (stateContext.customExamsLoaded && ((_a = stateContext.customExams) === null || _a === void 0 ? void 0 : _a.teachers)) {
            const migratedFrom = stateContext.getMigratedFromLockedProducts();
            const migratedTo = stateContext.getMigratedToLockedProducts();
            return stateContext.customExams.teachers.map((teacher) => {
                var _a;
                const teacherExamCount = (((_a = stateContext.customExams) === null || _a === void 0 ? void 0 : _a.customExamsData) || [])
                    .filter((exam) => {
                    var _a, _b;
                    const hasMatchingIsbn = this.props.context.lockedVersions.some((l) => exam.productData.some((e) => e.isbn === l.isbn));
                    const lockedMigratedFromProduct = migratedFrom.some((m) => m.versions.some((v) => exam.productData.some((e) => e.productVersionId === v.productVersionId)));
                    const lockedMigratedToProduct = migratedTo.some((m) => m.versions.some((v) => exam.productData.some((e) => e.productVersionId === v.productVersionId)));
                    if (hasMatchingIsbn) {
                        const hasMatchingVersions = exam.productData.every((e) => {
                            const version = this.props.context.lockedVersions.find((l) => l.isbn === e.isbn);
                            if (version)
                                return version.productVersionId === e.productVersionId;
                            return true;
                        });
                        return (hasMatchingVersions &&
                            !lockedMigratedFromProduct &&
                            !lockedMigratedToProduct);
                    }
                    const hasCampusEnabledVersions = (_b = (_a = this.props.context.products) === null || _a === void 0 ? void 0 : _a.campusEnabledVersions) === null || _b === void 0 ? void 0 : _b.some((p) => {
                        return exam.productData.some((pd) => pd.productVersionId === p);
                    });
                    return (!lockedMigratedFromProduct &&
                        !lockedMigratedToProduct &&
                        hasCampusEnabledVersions);
                })
                    .reduce((val, customExam) => customExam.teacherGuid === teacher.userGuid ? val + 1 : val, 0);
                return (React.createElement(T.Select.Option, { key: teacher.userGuid, value: teacher.userGuid, disabled: teacherExamCount === 0 },
                    teacher.firstName,
                    " ",
                    teacher.lastName,
                    " \u2013 [",
                    teacherExamCount === 0
                        ? 'No quizzes'
                        : `${teacherExamCount} ${teacherExamCount === 1 ? 'quiz' : 'quizzes'}`,
                    ' ',
                    "available]"));
            });
        }
        return null;
    }
    getExamsVersion(isbns) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.setState({ loading: true });
                const activeVersionInfo = yield LabSimService.getActiveExamsVersion(isbns);
                this.setState({
                    uniqueIsbns: activeVersionInfo.currentProductVersions,
                    loading: false,
                });
                return activeVersionInfo;
            }
            catch (error) {
                this.setState({
                    loading: false,
                });
                return error;
            }
        });
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.context.customExams && this.props.context.customExams) {
            this.getDistinctIsbns();
        }
    }
    componentDidMount() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.props.context.onProductsLoaded();
            if (this.props.context.customExams) {
                this.getDistinctIsbns();
            }
        });
    }
    render() {
        if (this.state.linkCreated) {
            if (this.state.response != null && this.state.response.responseType === 2) {
                return (React.createElement("form", { name: 'contentItems', method: 'POST', action: this.state.response.redirectUrl },
                    React.createElement("input", { type: 'hidden', value: this.state.response.jwt, id: 'JWT', name: 'JWT' }),
                    React.createElement("input", { type: 'submit', value: 'Post', ref: this.contentItemsSubmitRef, hidden: true })));
            }
            return (React.createElement(SuccessPage, { successAction: React.createElement(T.Text.H1, { automationId: 'sucAction' }, "Link to Custom Quiz Created"), onClickCallback: this.goToHome, moreInfo: this.state.isGraded ? (React.createElement(React.Fragment, null,
                    "Go to ",
                    React.createElement("i", null, "Assignments"),
                    " to find the link to CertMaster.")) : (React.createElement(React.Fragment, null,
                    "Go to ",
                    React.createElement("i", null, "Modules"),
                    " to find the link to CertMaster.")) }));
        }
        if (!this.state.isCreating && !this.state.isReadyToPost) {
            return (React.createElement(StateContext.Consumer, null, (stateContext) => {
                if (!stateContext.customExamsLoaded || !stateContext.productsLoaded)
                    return React.createElement(LoadingPage, { status: 'Loading Custom Exams' });
                if (this.state.loading)
                    return React.createElement(LoadingPage, { status: 'Loading Custom Exams' });
                return (React.createElement("div", { className: styles.container },
                    React.createElement(T.Text.H1, { variation: T.Text.Variation.H1_Large, automationId: 'title' }, "Create Link to Custom Quiz"),
                    React.createElement(T.InfoBox, { automationId: 'infoBox' },
                        React.createElement(T.InfoBox.Body, { variation: T.InfoBox.Variation.Custom, iconVariation: T.IconVariation.InfoCircle }, "A custom quiz must already be created within the platform to appear in this list.")),
                    React.createElement(T.Form, { className: styles.form, onSubmit: this.onContinue, automationId: 'customExamForm' },
                        React.createElement(T.Form.Field, { automationId: 'instructor', required: true },
                            React.createElement(T.Form.Label, null, "Custom Quiz Owner"),
                            React.createElement(T.Form.Select, { value: this.state.selectedTeacherGuid, onChange: this.selectTeacher, placeholder: 'Select instructor' }, this.getTeacherOptions(stateContext))),
                        React.createElement(T.Form.Field, { automationId: 'customExam', required: true },
                            React.createElement(T.Form.Label, null, "Custom Quiz"),
                            React.createElement("div", { key: this.state.selectedTeacherGuid },
                                React.createElement(T.Form.Select, { placeholder: 'Select custom quiz', disabled: !this.state.canSelectExam, onChange: this.selectProduct, value: this.state.selectedExam }, this.getCustomQuizOptions()))),
                        React.createElement(GradingControl, { defaultPointsPossible: this.state.possiblePoints, disabled: !this.state.isGraded, offText: PlatformHelper.getPlatform(stateContext.serverState).toLowerCase() === 'canvas'
                                ? 'This ungraded custom quiz will only be available in modules.'
                                : '', onChange: (e) => {
                                this.setState({
                                    isGraded: !e.disabled,
                                    possiblePoints: e.value,
                                    selectedAssignmentGroup: e.assignment,
                                });
                            }, onReady: (e) => this.setState({ selectedAssignmentGroup: e.assignment }) }),
                        React.createElement(ModulePublishControl, { publishDefault: false, allowNoneOption: this.state.isGraded, onChange: (e) => {
                                this.setState({
                                    selectedModule: e.module,
                                    selectedToPublish: e.publishOnCreation,
                                });
                            }, onReady: (e) => this.setState({ selectedModule: e.module }) }),
                        React.createElement(T.Form.RequiredIndicator, null),
                        React.createElement(T.Form.Footer, null,
                            React.createElement(T.Form.Cancel, { onClick: this.goToHome }, "Cancel"),
                            React.createElement(T.Form.Save, { disabled: !this.state.selectedExam || !!this.state.error }, "Create"))),
                    this.state.error && (React.createElement(T.WarningDialog, { onClose: () => this.setState({
                            error: '',
                            canCreate: false,
                            selectedExam: undefined,
                        }), title: 'Error', automationId: 'error' },
                        this.state.error,
                        React.createElement(SupportBox, null))),
                    React.createElement(PageFooter, null)));
            }));
        }
        else if (this.state.isCreating) {
            return React.createElement(LoadingPage, { status: React.createElement(React.Fragment, null, "Creating link to Custom Exam") });
        }
        else {
            return React.createElement(LoadingPage, null);
        }
    }
}
//# sourceMappingURL=CustomExams.js.map